export default {
  "block": "_block_z9ls89",
  "backgroundAnimation": "_backgroundAnimation_z9ls89"
};